import React from "react";
import { IItems } from "./index";
import {
  SettingIcon,
  UserIcon,
  ChatIcon,
  TextIcon,
  DashboardIcon,
  LetterIcon,
  ResourcesDownloadIcon,
} from "icons";

export const MenuItems: IItems[] = [
  {
    key: "5",
    icon: <DashboardIcon />,
    label: "ダッシュボード",
    path: "/dashboard",
  },
  {
    key: "1",
    icon: <UserIcon />,
    label: "ユーザー一覧",
    path: "/user-list",
  },
  {
    key: "2",
    icon: <ChatIcon />,
    label: "相談一覧",
    path: "/education-consultation-list",
  },
  // {
  //   key: "3",
  //   icon: <TextIcon />,
  //   label: "同意文作成",
  //   path: "/create-consent-statement",
  // },
  {
    key: "3",
    icon: <LetterIcon />,
    label: "メッセージ配信",
    path: "/message-delivery",
  },
  {
    key: "6",
    icon: <ResourcesDownloadIcon />,
    label: "資料ダウンロード",
    path: "/resources-download",
  },
  {
    key: "4",
    icon: <SettingIcon />,
    label: "各種設定",
    path: "/settings",
  },
];
// export const MESSAGE_URL = ["/messages", "/message-list"];
